import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Button, Form, Input, Select, Table, TextArea } from 'semantic-ui-react';
import { ElementOptionsI, WorkflowElement } from '../../models/template';
import { v4 as uuid } from 'uuid';
import { useStore } from '../../stores/store';
import DatePicker from 'react-datepicker';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { isInvalidFrame } from './types';

export type columnType = {
  optionName: string;
  optionType: string;
  isMulti?: boolean;
  isDisabled?: boolean;
  isSelected?: boolean;
  listOfOptions?: { text: string; value: string }[];
  newColoumn?: string;
  optionValue?:string
};

type DynamicRowsComponentProps = {
  options: ElementOptionsI[];
  saveDynamicTableData:
    | ((
        data: any,
        validationData: any,
        removed: any,
        added: any,
        // alterHistory: string,
        initialElementValue: any,
        headers: columnType[],
      ) => void)
    | undefined;
  elementDetails: WorkflowElement;
  readOnly: boolean;
  isMandatory: boolean;
  error: string | null;
  subTaskIdNo: string;
  mode?: number;
  subTaskName: string
};

function DynamicRowsComponent({
  options,
  saveDynamicTableData,
  elementDetails,
  readOnly,
  isMandatory,
  error,
  subTaskIdNo,
  mode = 1,
  subTaskName
}: DynamicRowsComponentProps) {
  const {
    PivotStore,
    commonStore,
    userStore,
    ElementStore,
    NFAI_Restoration_SmartflowsStore:{subtaskCompoent},
    masteringStore
  } = useStore();
  const isNFAIReport = userStore?.user?.customerName === 'NFAIReport';
  const [rowsData, setRowsData] = useState<any[]>([]);
  const [headers, setHeaders] = useState<columnType[]>([]);
  const [initialElementDetails, setInitialElementDetails] = useState<any>();
  const [errors, setErrors] = useState<{ key:string, value:string, index:number}[]>([]);

  const {
    userStore: { user },
    activityStore,
    viewStore: { activeOrder },
  } = useStore();
  const [endFrameMin, setEndFrameMin] = useState(0);
  // const [defectsData, setDefectsData] = useState<any[]>([]);
  useEffect(() => { 
    if (commonStore.staticDemoChanges) {
      const elementValueString = elementDetails?.elementValue;
      if (
        elementDetails?.elementName === 'Asset to be Rented' &&
        elementValueString &&
        elementValueString.trim() !== '[]'
      ) {
        try {
          const parsedElementValue = JSON.parse(
            elementValueString.split('|')[1] || '[]',
          );

          if (
            Array.isArray(parsedElementValue) &&
            parsedElementValue.length > 0
          ) {
            const updatedRowsData = [...rowsData];  
            parsedElementValue.forEach((item) => {
              const quantity = parseInt(item['Quantity']);
              const rentPerDay = parseFloat(item['Rent per Day']);
              const discountPercentage = parseFloat(item['Discount %']);
              if (!isNaN(quantity) && !isNaN(rentPerDay)) {
                let amount = 0;
                if (!isNaN(discountPercentage)) {
                  amount =
                    quantity * rentPerDay * (1 - discountPercentage / 100);
                } else {
                  amount = quantity * rentPerDay;
                }
                if (!isNaN(amount)) {
                   const rowIndex = updatedRowsData.findIndex(
                    (row) => row._uuid_ === item['_uuid_'],
                  );

                  if (rowIndex !== -1) {
                    updatedRowsData[rowIndex]['Amount'] = amount.toFixed(2);
                  }
                } else {
                  // If any of the values is NaN, set the Amount to 0
                  const rowIndex = updatedRowsData.findIndex(
                    (row) => row._uuid_ === item['_uuid_'],
                  );
                  if (rowIndex !== -1) {
                    updatedRowsData[rowIndex]['Amount'] = 0;
                  }
                }
              } else {
                // If any of the values is NaN, set the Amount to 0
                const rowIndex = updatedRowsData.findIndex(
                  (row) => row._uuid_ === item['_uuid_'],
                );
                if (rowIndex !== -1) {
                  updatedRowsData[rowIndex]['Amount'] = 0;
                }
              }
            });

            // Update the state with the updated data
            setRowsData(updatedRowsData);
            // Call the updateDyn_Row_TotalRentalAmount function with the totalAmount
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      }
    }
    // eslint-disable-next-line
  }, [elementDetails?.elementValue]);

  useEffect(() => {
  if (
    !commonStore.NFAIReportCustomer ||
    rowsData.length === 0 ||
    masteringStore.deliverableError.length === 0
  ) return;

  const mappedErrors = masteringStore.deliverableError.map((x) => ({
    key: x.key,
    value: x.value,
    index:
      x.mediaType === 'UHD'
        ? 0
        : x.mediaType === 'FHD'
        ? 1
        : x.mediaType === 'MP4'
        ? 2
        : x.mediaType === 'MP4_WATERMARK'
        ? 3
        : -1,
  }));

  setErrors(mappedErrors);
}, [rowsData.length, masteringStore.deliverableError, commonStore.NFAIReportCustomer]);


  // useEffect(() => {
  //   if (user?.customerName === 'Restoration') {
  //     // RestorationStore.qualityReport();
  //   }
  //   // eslint-disable-next-line
  // }, [user?.customerName]);

  // useEffect(() => {
  //   const temp = RestorationStore.qualityData?.filter(
  //     (data: any) => data.id === activityStore?.selectedActivity?.id,
  //   );
  //   if (temp.length) {
  //     setDefectsData(temp[0]?.defect);
  //   }
  //   // eslint-disable-next-line
  // }, [RestorationStore.qualityData]);

  const getInitialElementValues = async () => {
    let tempValue: any = [];
    if (subTaskIdNo !== '' || activityStore.metaDataVal?.metadata.length > 0) {
      let tempMetaData = [];
      if (subTaskIdNo) {
        tempMetaData = ElementStore.workflowSubTask.elements;
      } else {
        tempMetaData = activityStore.metaDataVal.metadata;
      }
      tempMetaData?.forEach(
        (ele: {
          elementType: string;
          elementId: string;
          elementValue: string;
        }) => {
          if (
            (ele.elementType === 'DynamicTable' &&
              ele.elementId === elementDetails.elementId) ||
            (ele.elementType === 'Dynamicmetadata' &&
              ele.elementValue?.split('|')?.[1] ===
                elementDetails.templateElementId)
          ) {
            tempValue = elementDetails;
          }
        },
      );
      setInitialElementDetails(tempValue);
    }
  };

  useEffect(() => {
    getInitialElementValues();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // eslint-disable-next-line
    options = Array.from(
      new Set(options.map((option) => option.optionName)),
    ).map(
      (optionName) =>
        options.find((option) => option.optionName === optionName)!,
    );
    options.sort(function (a, b) {
      return a.optionIndex - b.optionIndex;
    });
    const columnNames: columnType[] = [];
    columnNames.push({
      optionName: '_uuid_',
      optionType: 'textBox',
    });
    options?.forEach((data: ElementOptionsI) => {
      if (data.optionName !== '') {
        const optionList: { text: string; value: string }[] = [];
        if (data.listOfOptions) {
          const tempArr = JSON.parse(data.listOfOptions || '[]');
          tempArr?.forEach((data: string) => {
            optionList?.push({
              text: data,
              value: data,
            });
          });
        }
        columnNames.push({
          optionName: data.optionName,
          optionType: data.optionType || 'textBox',
          isMulti: data.isMulti || false,
          isDisabled: data.isDisabled || false,
          isSelected: data.isSelected || false,
          listOfOptions: optionList,
          optionValue: data.optionValue
        });
      }
    });
    if (isNFAIReport) {
      columnNames?.forEach((item: any) => (item.newColoumn = 'newColoumn'));
    }
    setHeaders(columnNames);
    var emptyRow: any = {};
    columnNames?.forEach((data: columnType) => {
      if (data.optionName === '_uuid_') {
        emptyRow[data.optionName] = uuid();
      } else if (data.optionType === 'datePicker') {
        emptyRow[data.optionName] = new Date();
      } else if (data.optionType === 'number') {
        emptyRow[data.optionName] = 0;
      } else if (data.optionType === 'currentUser') {
        emptyRow[data.optionName] = user?.displayName;
      } else {
        emptyRow[data.optionName] = '';
      }
    });
    const myRows = [...rowsData];
    if(myRows.length === 0){
      // if(user?.customerName === 'Restoration'){
      //    if(elementDetails?.elementName === 'Defects'&& TrackingReportStore.SmarttrackerClickStatus === 'Reject'){
      //      myRows.push(emptyRow);
      //    }
      //    else if(elementDetails?.elementName !== 'Defects'){
      //      myRows.push(emptyRow);
      //    }
      //  }
      //  else{
         myRows.push(emptyRow);
      //  }
    }
    setRowsData((prevRows) => {
      if (prevRows.length === 0) {
        const updatedRows = [...prevRows, emptyRow];
        return updatedRows;
      }
      return prevRows;
    });
    // eslint-disable-next-line
  }, [options]);

  useEffect(() => {
    if (
      elementDetails?.elementValue?.includes('[') &&
      elementDetails?.elementValue?.includes(']')
    ) {
      let elementValue = elementDetails?.elementValue.includes(
        'DynamicTable|',
      )
        ? parseJSON(elementDetails?.elementValue?.split('DynamicTable|')[1].replaceAll(/\n/g,''))
        : parseJSON(elementDetails?.elementValue);
      if (elementValue?.length === 0) {
        // handleAddRow();
      } else {
        const isDifferent = JSON.stringify(rowsData) !== JSON.stringify(elementValue);
        if (isDifferent && user?.customerName !== 'Restoration') {
          setRowsData(elementValue);
        }  else {
          if (
            user?.customerName !== 'Restoration' ||
            elementDetails?.elementName === 'Reject History'
          ) {
            setRowsData(elementValue);
          }
      }
    }
    }
    // eslint-disable-next-line
  }, [elementDetails?.elementValue]);


  const parseJSON = (stringData: string) => {
    let tempValue = [];
    try {
      // stringData = stringData.replaceAll(/\\/g, '');
      tempValue =
        stringData !== undefined &&
        typeof stringData === 'string' &&
        JSON.parse(stringData) !== undefined
          ? JSON.parse(stringData)
          : [];
      return tempValue;
    } catch (err) {
      return console.error('JSON ERROR:', err);
    }
  };

  useEffect(() => {
    const rowsDataId = rowsData?.map((a) => a?._uuid_);
    let initialElementValue = [];
    if (initialElementDetails?.elementValue) {
      initialElementValue = initialElementDetails?.elementValue?.includes(
        'DynamicTable|',
      )
        ? parseJSON(
            initialElementDetails?.elementValue?.split('DynamicTable|')[1],
          )
        : [];
    }
    // const initialElementValue = initialElementDetails?.elementValue?.includes(
    //   'DynamicTable|',
    // )
    //   ? JSON.parse(
    //       initialElementDetails?.elementValue?.split('DynamicTable|')[1],
    //     )
    //   : initialElementDetails?.elementValue !== undefined
    //   ? JSON.parse(initialElementDetails?.elementValue)
    //   : [];

    const initialElementValueIds = (initialElementValue || [])?.map(
      (a: { _uuid_: any }) => a?._uuid_,
    );
    const removed: any = [];
    const added: any = [];
    initialElementValue?.forEach((data: any) => {
      if (
        !rowsDataId?.includes(data?._uuid_) &&
        initialElementDetails?.elementId === elementDetails.elementId
      ) {
        removed.push(data);
      }
    });
    rowsData?.forEach((data: any) => {
      if (
        !initialElementValueIds?.includes(data?._uuid_) &&
        initialElementDetails?.elementId === elementDetails.elementId
      ) {
        added.push(data);
      }
    });
    //change date value
    rowsData?.forEach((alteredData: any) => {
      headers?.forEach((column: columnType) => {
        if (column.optionType === 'datePicker') {
          alteredData[column.optionName] = PivotStore.dateFormat(
            alteredData[column.optionName],
          );
        }
      });
    });

    saveDynamicTableData?.(
      rowsData,
      elementDetails,
      removed,
      added,
      initialElementValue,
      headers,
      // alterHistory,
    );
    // eslint-disable-next-line
  }, [rowsData, initialElementDetails?.elementValue]);

  const NfaiRestorationRemoverHandler = () => {
    const taskDetails: any =
      activeOrder?.tasks?.find((task) => task?.isCurrentTask) || [];
    const currentSubTaskDetails: any = taskDetails?.subTasks?.find(
      (subTask: any) => subTask.isCurrentSubtask,
    );
    if (
      taskDetails?.taskName === 'Restoration' &&
      currentSubTaskDetails?.subTaskName === 'Restoration' &&
      activityStore?.selectedActivity?.title.includes('Cutlist')
    ) {
      return false;
    } else {
      return true;
    }
  };

  const NFAIFramerHandler = (name: string, rowsInput: any[], index: number) => {
    const isStartOrEndFrame = ['Start Frame', 'End Frame'].includes(name);
    const isError_Start_FrameOrError_End_Frame = [
      'Error_Start_Frame',
      'Error_End_Frame',
    ].includes(name);
    if (isStartOrEndFrame) {
      const startFrame = rowsInput[index]['Start Frame'] || '0';
      const endFrame = rowsInput[index]['End Frame'] || '0';
      const hasValidFrames = startFrame !== '' && endFrame !== '';
      if (hasValidFrames) {
        rowsInput[index]['Number_of_Frames_Affected'] = Math.max(
          parseInt(endFrame) - parseInt(startFrame) + 1,
          0,
        );
      } else {
        rowsInput[index]['Number_of_Frames_Affected'] = 0;
      }
    }

    if (isError_Start_FrameOrError_End_Frame) {
      const Error_Start_Frame = rowsInput[index]['Error_Start_Frame'] || '0';
      const Error_End_Frame = rowsInput[index]['Error_End_Frame'] || '0';
      const hasValidFrames = Error_End_Frame !== 0 && Error_Start_Frame !== 0;
      if (hasValidFrames) {
        rowsInput[index]['Error_Total_Frame'] = Math.max(
          parseInt(Error_End_Frame) - parseInt(Error_Start_Frame) + 1,
          0,
        );
      } else {
        rowsInput[index]['Error_Total_Frame'] = 0;
      }
    }
    setRowsData(rowsInput);
  };

  const HandleTimeCode = (input:string, reelNo:string) => {
    let frameRate = 24;
    let value = parseInt(input, 10); // Parse input string to integer with radix 10
    if (isNaN(value)) {
        // If input cannot be parsed to an integer, return an empty string or handle the error accordingly
        return "";
    }
    let totalSeconds = value / frameRate;
    let minutes = Math.floor((totalSeconds % 3600) / 60);
    let seconds = Math.floor(totalSeconds % 60);
    let valueMod24 = value % 24;

    let result = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    const reelMatch = reelNo.match(/\d+/);
    const reelNumber = reelMatch ? reelMatch[0].padStart(2, '0') : '00';
    result = `${reelNumber}:${result}:${valueMod24.toString().padStart(2, '0')}`;
    return result;
}

const TimeCodeToFrame = (timecode: string): number | null => {
    const frameRate = 24;
    const parts = timecode.split(':');

    if (parts.length !== 4) {
        return null; // Invalid format
    }

    // eslint-disable-next-line
    const [reel, mm, ss, ff] = parts;
    const minutes = parseInt(mm, 10);
    const seconds = parseInt(ss, 10);
    const frames = parseInt(ff, 10);

    if ([minutes, seconds, frames].some(isNaN)) {
        return null; // Invalid time values
    }

    const totalSeconds = (minutes * 60) + seconds;
    const totalFrames = (totalSeconds * frameRate) + frames;
    return totalFrames;
};


  const  removeLeadingZero = (value:string) => {
    if (typeof value === 'string' && value.startsWith('0')) {
        return parseInt(value, 10); // Convert string to integer
    }
    return value; // Return original value
}

  const handleChange = (
    index: number,
    evnt: { target: { name: any; value: any } },
  ) => {
    const { name, value } = evnt.target;
    const rowsInput = [...rowsData];

    const subTaskNameExceptions = ['encrypted qc report', 'open qc report', 'deliverables qc report', 'dpx qc report', 'dsm qc report', 'lto qc report'];
    const shouldRemoveLeadingZero = !subTaskNameExceptions.includes(subTaskName?.toLowerCase());
    // Update row data
    const filteredValue = shouldRemoveLeadingZero ? removeLeadingZero(value) : value;
    rowsInput[index][name] = filteredValue;
    // Check if user is 'Restoration'
    if (user?.customerName === 'Restoration') {
      const updateFrame = ()=>{
        rowsInput[index]['Total Frame'] =
          parseInt(rowsInput[index]['End Frame']) -
          parseInt(rowsInput[index]['Start Frame']) +
          1;
      }
      if (name === 'End Frame') {
        updateFrame();
      } else if (name === 'Start Frame') {
        rowsInput[index]['End Frame'] = parseInt(value) + 1;
        updateFrame();
        setEndFrameMin(value);
      }
    }

    // Check for discount changes in static demo
    if (commonStore.staticDemoChanges && name === 'Discount %') {
      const discountValue = parseFloat(value);
      if (!isNaN(discountValue)) {
        rowsInput[index][name] = Math.min(Math.max(discountValue, 0), 100);
      }
    }
    // NFAI-Restoration customer
    if(commonStore.NFAIReportCustomer){
     if(name === "Time_code" || name === "Time-code") {
       const includesTimeCode = value?.toString()?.replace(/–|—/g, "-").includes("-")
        if(includesTimeCode) { 
        rowsInput[index]['Start Frame'] = TimeCodeToFrame(value?.toString()?.replace(/–|—/g, "-")?.split('-')[0].trim());
        rowsInput[index]['End Frame'] = TimeCodeToFrame(value?.toString()?.replace(/–|—/g, "-")?.split('-')[1].trim())
        }
        else { 
        rowsInput[index]['Start Frame'] = "";
        rowsInput[index]['End Frame'] = "";
        }
        rowsInput[index]['Number of Frames Affected'] = rowsInput[index]['End Frame'] - rowsInput[index]['Start Frame'] + 1; 
        rowsInput[index]['No_of_Frames_Affected'] = rowsInput[index]['End Frame'] - rowsInput[index]['Start Frame'] + 1; 
        rowsInput[index][name] = value;
     }
      const isStartAndEndFrame = ['End Frame', 'Start Frame'].includes(name);

      const isTimeCode = isStartAndEndFrame &&
      (elementDetails?.elementName === 'Overall Remark' ||
        elementDetails?.elementName ===
          'NFHM QC Restoration Supervisor Feedback' ||
        elementDetails?.elementName === 'Image Restoration' ||
        elementDetails?.elementName === 'NFHM Grading QC Supervisor Feedback');// eslint-disable-next-line
        const isDmReportCalculation = ['Total Frames', 'Actual Frames'].includes(name) || isStartAndEndFrame && 
        elementDetails?.elementName === 'DM Report';

    const reelNo = rowsInput[index]['Reel No'] || rowsInput[index]['Reel no.']

    const startFrame = rowsInput[index]['Start Frame']
    const endFrame = rowsInput[index]['End Frame']
    const parsedStartFrame = parseInt(startFrame)
    const parsedEndFrame = parseInt(endFrame);
    const isReelNo = name === 'Reel No' || name === 'Reel no.'

    if (elementDetails?.elementName === 'DM Report' || elementDetails?.elementName === 'Grading Report') {
      // Function to validate the frames
         const actualFrames = 
        (parsedEndFrame < parsedStartFrame) || isInvalidFrame(parsedStartFrame) || isInvalidFrame(parsedEndFrame) || parsedEndFrame === 0
          ? '' 
          : isStartAndEndFrame 
            ? `${parsedEndFrame - parsedStartFrame + 1}` 
            : rowsInput[index]['Actual Frames'];
    
      rowsInput[index]['Actual Frames'] = actualFrames;
    }
    
    // Handle NFAI report and time code updates
    if (!isTimeCode && !isReelNo) {  
      NFAIFramerHandler(name, rowsInput, index);
    }// eslint-disable-next-line
    else if (isReelNo && (reelNo === '' || reelNo === undefined) || (parsedEndFrame < parsedStartFrame) || (parsedEndFrame === parsedStartFrame)) {
      rowsInput[index]['Time-code'] = '';
      rowsInput[index]['Time_code'] = '';
    }
     else if ( startFrame !== '' && endFrame !== '' && reelNo !== '' && parsedEndFrame > parsedStartFrame ) {
      const startTimeCode = HandleTimeCode(startFrame, reelNo); 
      const endTimeCode = HandleTimeCode(endFrame,reelNo);
      // Update time code-related fields    
      rowsInput[index]['End Time Code'] = endTimeCode;
      rowsInput[index]['Start Time Code'] = startTimeCode;
      rowsInput[index]['Time_code'] = `${startTimeCode}-${endTimeCode}`;
      rowsInput[index]['Time-code'] = `${startTimeCode}-${endTimeCode}`;
      rowsInput[index]['Number of Frames Affected'] = `${endFrame - startFrame + 1}`
      rowsInput[index]['No_of_Frames_Affected'] =  `${endFrame - startFrame + 1}`
    }
    else if(startFrame === '' || endFrame === '' || reelNo === ''){
      rowsInput[index]['Start Time Code'] = '';
      rowsInput[index]['End Time Code'] = '';
      rowsInput[index]['Time-code'] = '';
      rowsInput[index]['Time_code'] = '';
    }
    if(isDmReportCalculation){
      rowsInput[index]['Total Frames'] === rowsInput[index]['Actual Frames'] ? rowsInput[index]['Approved (Yes / No)'] = 'Yes' : rowsInput[index]['Approved (Yes / No)'] = 'No'
    } 
    }
    // Check if it is a specific element name
   
    if(commonStore.NFAIReportCustomer) {
       setErrors((prevErrors) =>
        prevErrors.filter(
          (err) => !(err.key === name && err.index === index)
        )
        );
    }
    // Update rowsData
    setRowsData(rowsInput);
  };

  const NFAIIsDisabledHandler = (name?: string, disable?: boolean) => {
    if (disable) {
      return 'component-isDisabled';
    } else if(name === 'Reject By' || name === 'Reject Date'){
      return 'component-isDisabled';
    } else if (name === 'Feedback') {
      const status = statusCheckHandler();
      if (status?.subTaskName === 'Restoration') {
        return 'component-isDisabled';
      } else {
        return '';
      }
    } else if (
      name === 'Number of Frames Affected' ||
      name === 'No_of_Frames_Affected' ||
      name === 'Error_Total_Frame'
    ) {
      return 'component-isDisabled';
    } else {
      return '';
    }
  };

  const dateChange = (date: string, index: number, name: string) => {
    const newDate = PivotStore.dateFormat(date);
    const rowsInput = [...rowsData];
    rowsInput[index][name] = newDate;
    setRowsData(rowsInput);
  };

  const handleAddRow = () => {
    var emptyRow: any = {};
    headers?.forEach((data: columnType) => {
      if (data.optionName === '_uuid_') {
        emptyRow[data.optionName] = uuid();
      } else if (data.optionType === 'datePicker') {
        emptyRow[data.optionName] = new Date();
      } else if (data.optionType === 'number') {
        emptyRow[data.optionName] = 0;
      } else if (data.optionType === 'currentUser') {
        emptyRow[data.optionName] = user?.displayName;
      } else {
        emptyRow[data.optionName] = '';
      }
    });
    const myRows = [...rowsData];
    if (isNFAIReport) {
      emptyRow.newColoumn = true;
    }
    myRows.push(emptyRow);
    setRowsData(myRows);
  };

  const handleRemoveSpecificRow = (index: number) => {
    const myRows = [...rowsData];
    myRows.splice(index, 1);
    setRowsData(myRows);
  };

  // const handleRemoveRow = () => {
  //   const myRows = [...rowsData];
  //   myRows.pop();
  //   setRowsData(myRows);
  // };

  const setDropdownValue = (
    index: number,
    _e: any,
    data: any,
    name: string,
  ) => {
    const updatedRows = [...rowsData];
    updatedRows[index][name] = data.value;
       if(commonStore.NFAIReportCustomer) {
       setErrors((prevErrors) =>
        prevErrors.filter(
          (err) => !(err.key === name && err.index === index)
        )
        );
    }
    setRowsData(updatedRows);
  };

  // const renderHeader = () => {
  //   return (
  //     <Table.Header>
  //       <Table.Row>
  //         <Table.HeaderCell>Defect Type</Table.HeaderCell>
  //         <Table.HeaderCell>Defect Start Frame</Table.HeaderCell>
  //         <Table.HeaderCell>Defect End Frame</Table.HeaderCell>
  //         <Table.HeaderCell>Defect Total Frame</Table.HeaderCell>
  //         <Table.HeaderCell>Position</Table.HeaderCell>
  //         <Table.HeaderCell>Severity</Table.HeaderCell>
  //         <Table.HeaderCell>Reject Type</Table.HeaderCell>
  //       </Table.Row>
  //     </Table.Header>
  //   );
  // };

  // const filterDefects = (defects: any, index: number) => {
  //   switch (mediaAssetStore.mediaAsset.taskname) {
  //     case 'Dust Busting':
  //       return (
  //         <>
  //           {defects.rejectby === 'Dust Busting QC' &&
  //             defects.defects_Type !== '' && (
  //               <>
  //                 <Table.Body key={index}>
  //                   <Table.Row>
  //                     <Table.Cell>{defects.defects_Type}</Table.Cell>
  //                     <Table.Cell>{defects.sDefect_SF}</Table.Cell>
  //                     <Table.Cell>{defects.sDefect_EF}</Table.Cell>
  //                     <Table.Cell>{defects.sDefect_TF}</Table.Cell>
  //                     <Table.Cell>{defects.position}</Table.Cell>
  //                     <Table.Cell>{defects.severity}</Table.Cell>
  //                     <Table.Cell>{defects.rejectby}</Table.Cell>
  //                   </Table.Row>
  //                 </Table.Body>
  //               </>
  //             )}
  //         </>
  //       );
  //     case 'Full Restoration':
  //       return (
  //         <>
  //           {(defects.rejectby === 'Quality Check' ||
  //             defects.rejectby === 'Final Quality Analysis' ||
  //             defects.rejectby === 'Wave Production' ||
  //             defects.rejectby === 'CC Form Production') &&
  //             defects.defects_Type !== '' && (
  //               <>
  //                 <Table.Body key={index}>
  //                   <Table.Row>
  //                     <Table.Cell>{defects.defects_Type}</Table.Cell>
  //                     <Table.Cell>{defects.sDefect_SF}</Table.Cell>
  //                     <Table.Cell>{defects.sDefect_EF}</Table.Cell>
  //                     <Table.Cell>{defects.sDefect_TF}</Table.Cell>
  //                     <Table.Cell>{defects.position}</Table.Cell>
  //                     <Table.Cell>{defects.severity}</Table.Cell>
  //                     <Table.Cell>{defects.rejectby}</Table.Cell>
  //                   </Table.Row>
  //                 </Table.Body>
  //               </>
  //             )}
  //         </>
  //       );
  //     default:
  //       return (
  //         <>
  //           {mediaAssetStore.mediaAsset.taskname === defects.rejectby &&
  //             defects.defects_Type !== '' && (
  //               <>
  //                 <Table.Body key={index}>
  //                   <Table.Row>
  //                     <Table.Cell>{defects.defects_Type}</Table.Cell>
  //                     <Table.Cell>{defects.sDefect_SF}</Table.Cell>
  //                     <Table.Cell>{defects.sDefect_EF}</Table.Cell>
  //                     <Table.Cell>{defects.sDefect_TF}</Table.Cell>
  //                     <Table.Cell>{defects.position}</Table.Cell>
  //                     <Table.Cell>{defects.severity}</Table.Cell>
  //                     <Table.Cell>{defects.rejectby}</Table.Cell>
  //                   </Table.Row>
  //                 </Table.Body>
  //               </>
  //             )}
  //         </>
  //       );
  //   }
  // };

  const statusCheckHandler = () => {
    const findCurrentSubtask = (data: any) => {
      const currentTask = data.tasks.find((task: any) => task.isCurrentTask);
      return currentTask
        ? currentTask.subTasks.find((subtask: any) => subtask.isCurrentSubtask)
        : null;
    };
    const currentSubtask = findCurrentSubtask(activeOrder);
    return currentSubtask;
  };
  const NFAIDisable = (fieldName: string, disable?: boolean) => {
    if (user?.customerName === 'NFAIReport') {
        const currentSubtask = statusCheckHandler();
      if (
        // (currentSubtask?.subTaskName === 'Restoration' &&
        //   fieldName === 'Approved/ Not_Approved') ||
        (currentSubtask?.subTaskName === 'Restoration' &&
          fieldName === 'Feedback') 
        // || (fieldName === 'Time_code' || fieldName ===  'Time-code')
      ) {
        return true;
      }
       else {
        if (disable) {
          return true;
        } else {
          return false;
        }
      }
    }
    return false;
  };


  const onDragEnd = (result:any) => {
    if (!result.destination) return;

    const items = Array.from(rowsData);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setRowsData(items);
  };


const renderField = (
  type: string,
  name: string,
  value: any,
  index: number,
  isMulti: boolean = false,
  isDisabled: boolean = false,
  listOfOptions: { text: string; value: string }[] = [],
) => {
  const fieldError = errors.find(
    (e) => e.key === name && e.index === index
  );

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  switch (type) {
    case 'textBox':
      return (
        <Form.Field error={!!fieldError}>
          <Form.Input
            name={name}
            value={value}
            onChange={(_e: any) => handleChange(index, _e)}
            onKeyDown={handleKeyDown}
            style={{ minWidth: '12em' }}
          />
          {fieldError && (
            <div className="ui pointing red basic label">
              {fieldError.value}
            </div>
          )}
        </Form.Field>
      );

    case 'textArea':
      return (
        <Form.Field error={!!fieldError}>
          <TextArea
            name={name}
            value={value}
            onChange={(_e: any) => handleChange(index, _e)}
            onKeyDown={handleKeyDown}
            style={
              name === 'Remarks_by_Vendor_QC_Technician/Supervisor'
                ? { minWidth: '20em' }
                : { minWidth: '14em' }
            }
            disabled={isDisabled || NFAIDisable(name, isDisabled)}
            className={NFAIIsDisabledHandler(name, isDisabled)}
          />
          {fieldError && (
            <div className="ui pointing red basic label">
              {fieldError.value}
            </div>
          )}
        </Form.Field>
      );

    case 'currentUser':
      return (
        <Form.Input name={name} value={value} disabled />
      );

    case 'number':
      return (
        <Form.Field error={!!fieldError}>
          <Form.Input
            name={name}
            type="number"
            value={
              user?.customerName === 'Restoration'
                ? value
                : removeLeadingZero(value)?.toString()
            }
            onChange={(_e: any) => handleChange(index, _e)}
            onKeyDown={handleKeyDown}
            disabled={
              user?.customerName === 'Restoration'
                ? name === 'Total Frame' || isDisabled
                : isDisabled
            }
            min={
              user?.customerName === 'Restoration'
                ? name === 'Start Frame' || name === 'Total Frame'
                  ? 0
                  : name === 'End Frame' && endFrameMin
                : undefined
            }
            className={NFAIIsDisabledHandler(name, isDisabled)}
          />
          {fieldError && (
            <div className="ui pointing red basic label">
              {fieldError.value}
            </div>
          )}
        </Form.Field>
      );

    case 'checkBox':
      return <Input type="checkbox" />;

    case 'datePicker':
      return (
        <DatePicker
          showMonthDropdown
          showYearDropdown
          value={PivotStore.dateFormat(value)}
          onChange={(date: any) => dateChange(date, index, name)}
          disabled={isDisabled}
          className={isDisabled ? 'component-isDisabled' : ''}
        />
      );

    case 'dropDown':
      return (
        <Form.Field error={!!fieldError}>
          <Select
            value={value}
            onChange={(_e: any, data: any) =>
              setDropdownValue(index, _e, data, name)
            }
            options={listOfOptions}
            placeholder={`Select ${name}`}
            multiple={isMulti}
            search
            clearable
            disabled={NFAIDisable(name, isDisabled)}
            className={
              isDisabled
                ? 'component-isDisabled'
                : userStore?.user?.customerName === 'Museum' &&
                  name === 'Remarks of Condition'
                ? 'RemarksofConditionDropdown'
                : ''
            }
          />
          {fieldError && (
            <div className="ui pointing red basic label">
              {fieldError.value}
            </div>
          )}
        </Form.Field>
      );

    default:
      return null;
  }
};


  return (
    <div className={readOnly && commonStore.NFAIReportCustomer ? 'elementReadonly-reject' : readOnly ? 'elementReadonly' :  '' } style={subtaskCompoent.isModel ? {fontSize:'11px'} : commonStore.NFAIReportCustomer ? { fontSize:'11px' } : {}}>
      {/* {user?.customerName === 'Restoration' && defectsData?.length > 0 && (
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Defect Type</Table.HeaderCell>
              <Table.HeaderCell>Defect Start Frame</Table.HeaderCell>
              <Table.HeaderCell>Defect End Frame</Table.HeaderCell>
              <Table.HeaderCell>Defect Total Frame</Table.HeaderCell>
              <Table.HeaderCell>Position</Table.HeaderCell>
              <Table.HeaderCell>Severity</Table.HeaderCell>
              <Table.HeaderCell>Reject Type</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          {defectsData?.map((defects: any, index: number) => {
            return <>{filterDefects(defects, index)}</>;
          })}
        </Table>
      )} */}
      <label style={{ marginBottom: '12px', display: 'inline-block' }}>
        <span className={error ? 'errorColor' : ''}>
          {elementDetails?.elementName} 
        </span>
      </label>
      {isMandatory ? <span className="errorColor">*</span> : null}
      <div className="container">
        <div className="row clearfix">
          <div className="col-md-12 column">
              {commonStore.NFAIReportCustomer && !activityStore?.selectedActivity?.title.includes('Cutlist ') &&
                !activityStore?.selectedActivity?.title.includes('Reel') && 
                subTaskName === 'Restoration' && elementDetails.elementName === 'Image Restoration' ? 
                <DragDropContext onDragEnd={onDragEnd}>
      <Table striped className={mode === 0 ? 'dynamic-rows component-isDisabled' : 'dynamic-rows'}>
        
        {/* Your Table Header */}
        <Table.Body>
        <Table.Header>
                <Table.Row className='flex-container'>
                  {headers?.map((columnName: columnType) => {
                    return (
                      <>
                        {columnName.optionName !== '_uuid_' ? (
                          <Table.Cell className={error ? 'negative child-element' : 'child-element'}>
                            {columnName.optionName?.split('_')?.join(' ')}
                            {columnName?.isSelected && (
                              <span style={{ color: '#db2828' }}>*</span>
                            )}
                          </Table.Cell>
                        ) : (
                          <Table.Cell disabled className={'child-element'}>S.No.</Table.Cell>
                        )}
                      </>
                    );
                  })}
                  <Table.Cell className={error ? 'negative' : ''}></Table.Cell>
                </Table.Row>
              </Table.Header> 
          <Droppable droppableId="rows">
            {(provided) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                       
                {rowsData.map((row, index) => (
                  <Draggable key={index} draggableId={`row-${index}`} index={index}>
                    {(provided) => (
                      <tr
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        
                      >
                        {headers.map((header, idx) => (
                          <Table.Cell key={idx}>
                            {header.optionName !== '_uuid_' ? (
                              renderField(
                                header.optionType,
                                header.optionName,
                                row[header.optionName],
                                index,
                                header.isMulti,
                                isNFAIReport && row[header?.newColoumn as string] === true
                                  ? false
                                  : header.isDisabled,
                                header.listOfOptions
                              )
                            ) : (
                              index + 1
                            )}
                          </Table.Cell>
                        ))}
                        <Table.Cell>
                          <Button onClick={() => handleRemoveSpecificRow(index)}>Remove</Button>
                        </Table.Cell>
                      </tr>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </Table.Body>
      </Table>
    </DragDropContext>
          
             :  <>
               <Table
              striped
              className={
                mode === 0
                  ? 'dynamic-rows component-isDisabled'
                  : 'dynamic-rows'
              }
            >
              <Table.Header>
                <Table.Row>
                  {headers?.map((columnName: columnType) => {
                    return (
                      <>
                        {columnName.optionName !== '_uuid_' ? (
                          <Table.Cell className={error ? 'negative' : ''}>
                            {columnName.optionName?.split('_')?.join(' ')}
                            {columnName?.isSelected && (
                              <span style={{ color: '#db2828' }}>*</span>
                            )}
                          </Table.Cell>
                        ) : (
                          <Table.Cell disabled>S.No.</Table.Cell>
                        )}
                      </>
                    );
                  })}
                  <Table.Cell className={error ? 'negative' : ''}></Table.Cell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {rowsData &&
                  rowsData?.map((idx: any, index: number) => {
                    return (
                      <Table.Row key={index}>
                        {headers?.map((header: columnType) => {
                          return (
                            <>
                              {header.optionName !== '_uuid_' ? (
                                <Table.Cell>
                                  {renderField(
                                    header.optionType,
                                    header.optionName,
                                    header.optionName==="Package No"? index+1:idx[header.optionName],
                                    index,
                                    header.isMulti,
                                    isNFAIReport &&
                                      idx[header?.newColoumn as string] === true
                                      ? false
                                      : header.isDisabled,
                                    header.listOfOptions,
                                  )}
                                </Table.Cell>
                              ) : (
                                <Table.Cell disabled>{index + 1}</Table.Cell>
                              )}
                            </>
                          );
                        })}

                        <Table.Cell>
                          {NfaiRestorationRemoverHandler() && (
                            <Button
                              onClick={() => {
                                handleRemoveSpecificRow(index);
                              }}
                            >
                              Remove
                            </Button>
                          )}
                        </Table.Cell>
                      </Table.Row>
                    );
                  })}
              </Table.Body>
            </Table>
          </>}
            {user?.customerName === 'Restoration' && (
              <div style={{ marginBottom: '16px' }}>
                * Start Frame & End Frame cannot be negative. Also, End Frame
                should be greater than Start Frame.
              </div>
            )}
          {/* In this condition removed remove button that why we removed but Proper resson we dotnot know. */}
            {NfaiRestorationRemoverHandler() && (
            <Button onClick={handleAddRow}>Add Row</Button>)}
            {/* <Button onClick={handleRemoveRow}>Delete Last Row</Button> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default observer(DynamicRowsComponent);
